module.exports = __webpack_public_path__ + "@/assets/img/es-mx.219c348f.svg";